// Returns true when an axios response resolved with a 2xx success status.
export function isSuccessfulResponse(response) {
    return Boolean(response) && response.status >= 200 && response.status < 300;
}
